exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-reportContentLayout-UncertaintyCalculation-infoSection{-webkit-box-shadow:0 0 1px rgba(0,0,0,.5);box-shadow:0 0 1px rgba(0,0,0,.5);color:#dc3545;border:2px solid #dc3545 !important;border-radius:0 !important;padding:0 10px 0;margin-bottom:20px}.src-components-reportContentLayout-UncertaintyCalculation-infoSection .src-components-reportContentLayout-UncertaintyCalculation-toggle{padding:10px}.src-components-reportContentLayout-UncertaintyCalculation-infoSection .src-components-reportContentLayout-UncertaintyCalculation-dataBlock{padding:0 10px 0}", ""]);

// exports
exports.locals = {
	"infoSection": "src-components-reportContentLayout-UncertaintyCalculation-infoSection",
	"toggle": "src-components-reportContentLayout-UncertaintyCalculation-toggle",
	"dataBlock": "src-components-reportContentLayout-UncertaintyCalculation-dataBlock"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/reportContentLayout/UncertaintyCalculation/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/reportContentLayout/UncertaintyCalculation/styles.scss
// module chunks = 1